import Vue from 'vue';
import { config } from '@/config';

class ConfigPlugin {
  public static install(vue: typeof Vue, options?: any) {
    if (!vue.prototype.$bus) {
      Object.defineProperties(vue.prototype, {
        $config: {
          get() {
            return config;
          },
        },
      });
    }
  }
}

export { ConfigPlugin };
